import { Component, OnInit } from '@angular/core';
import { SharedService } from './../../../services';
import * as SunCalc from 'suncalc2';

@Component({
  selector: 'sunrise',
  templateUrl: './sunrise.component.html',
  styleUrls: ['./sunrise.component.scss']
})
export class SunriseComponent implements OnInit {

  constructor(private _shared: SharedService) { }

  selectedCity;
  sunValues: any;
  moonValues: any;
  timeUTC;
  canIuseCalc = true;
  deg = -137;
  circleSun;

  getDateUTC() {
    let date = new Date();
    return new Date(
      Date.UTC(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        // date.getUTCHours() + (!this.timeUTC ? Number(this.selectedCity.timezone) : 0),
        date.getUTCHours(),
        date.getUTCMinutes()
      )
    );
  }
  calculateSunrise() {
    this.canIuseCalc = false;
    setTimeout(() => this.canIuseCalc = true, 900);
    let date = this.getDateUTC();
    let date4IlluminationMoon = new Date((date.getTime() + date.getTimezoneOffset()*60000)+3600000*this.selectedCity.timezone);
    let date4IlluminationMoon2 = new Date((date.getTime() + date.getTimezoneOffset()*60000)+3600000*3);
    this.sunValues = SunCalc.getTimes(date, this.selectedCity.lat, this.selectedCity.lng);
    let current = Date.UTC(
      date.getUTCFullYear(),
      date.getUTCMonth(),
      date.getUTCDate(),
      date.getUTCHours(),
      date.getUTCMinutes()
    )
    // console.log(current);
    let from = Date.UTC(
      this.sunValues.sunrise.getUTCFullYear(),
      this.sunValues.sunrise.getUTCMonth(),
      this.sunValues.sunrise.getUTCDate(),
      this.sunValues.sunrise.getUTCHours(),
      this.sunValues.sunrise.getUTCMinutes()
    );
    let to = Date.UTC(
      this.sunValues.sunsetStart.getUTCFullYear(),
      this.sunValues.sunsetStart.getUTCMonth(),
      this.sunValues.sunsetStart.getUTCDate(),
      this.sunValues.sunsetStart.getUTCHours(),
      this.sunValues.sunsetStart.getUTCMinutes()
    );
    this.circleSun = current >= from || current <= to;
    let difPercent = 100/(to - from)*(current - from);
    this.deg = -137+(100/95*difPercent);
    this.moonValues = new SunCalc.getMoonIllumination(date4IlluminationMoon);
    // this.moonValues = new SunCalc.getMoonIllumination(date);
    let currplace = new SunCalc.getMoonIllumination(date4IlluminationMoon);
    let belplace = new SunCalc.getMoonIllumination(date4IlluminationMoon2);
    // console.log((currplace.fraction*100).toFixed(2), `angle: ${currplace.angle*57.2958}`);
    // console.log((belplace.fraction*100).toFixed(2), `angle: ${belplace.angle*57.2958}`);
    // console.log('this.moonValues',this.sunValues,this.moonValues);
  }
  getTimezone() {
    return this.timeUTC ? '+0' : (this.selectedCity.timezone < 0 ? '' + this.selectedCity.timezone : '+' + this.selectedCity.timezone)
  }
  getMoonPhase() {
    if (this.moonValues.phase < 0.05) return 1; //0
    if (this.moonValues.phase >= 0.05 && this.moonValues.phase < 0.20) return 2; //0-0.25
    if (this.moonValues.phase >= 0.20 && this.moonValues.phase < 0.30) return 3; //0.25
    if (this.moonValues.phase >= 0.30 && this.moonValues.phase < 0.45) return 4; //0.25-0.5
    if (this.moonValues.phase >= 0.45 && this.moonValues.phase < 0.55) return 5; //0.5
    if (this.moonValues.phase >= 0.55 && this.moonValues.phase < 0.70) return 6; //0.5-0.75
    if (this.moonValues.phase >= 0.70 && this.moonValues.phase < 0.80) return 7; //0.75
    if (this.moonValues.phase >= 0.8) return 8; //0.75-1
  }
  getMoonPhaseText() {
    if (this.moonValues.phase < 0.05) return 'Новолуние'; //0
    if (this.moonValues.phase >= 0.05 && this.moonValues.phase < 0.20) return 'Растущий серп'; //0-0.25
    if (this.moonValues.phase >= 0.20 && this.moonValues.phase < 0.30) return 'Первая четверть'; //0.25
    if (this.moonValues.phase >= 0.30 && this.moonValues.phase < 0.45) return 'Растущая луна'; //0.25-0.5
    if (this.moonValues.phase >= 0.45 && this.moonValues.phase < 0.55) return 'Полнолуние'; //0.5
    if (this.moonValues.phase >= 0.55 && this.moonValues.phase < 0.70) return 'Убывающая луна'; //0.5-0.75
    if (this.moonValues.phase >= 0.70 && this.moonValues.phase < 0.80) return 'Последняя четверть'; //0.75
    if (this.moonValues.phase >= 0.8) return 'Убывающая Луна'; //0.75-1
  }
  ngOnInit() {
    this._shared.currentCity.subscribe(city => {
      this.selectedCity = city;
      this.canIuseCalc && this.calculateSunrise();
    });
    this._shared.currentTime.subscribe(time => {
      this.timeUTC = time;
      // console.log(!this.timeUTC ? this.selectedCity.timezone : 0);
      this.canIuseCalc && this.calculateSunrise();
    });
  }

}

